import React, {Component} from 'react';
import {Container, Row, Col, Button, Form, Badge} from 'react-bootstrap';
import {getUserToken} from '../../../redux/actions/user';
import ReactTable from 'react-table';
import axios from 'axios';


class ContactRequestsAdmin extends  Component {

    constructor (props) {
        super(props);

        this.btnRef = React.createRef();
        this.baseUrl = 'https://service.todab.org.tr';

        this.state = {
            data: []
        };
    }


    getToken() {
        return sessionStorage.getItem('x-user-token') || false;
    }

    getExcel(additionalUrl = 'iletisim-istekleri') {
        let params = {excel: true};
        axios.get(`${this.baseUrl}/reports/${additionalUrl}`, {
            params: params,
            headers:
                {
                    'Authorization': `Bearer ${this.getToken()}`
                }
        })
             .then(
                 response => {
                     this.btnRef.current.href = response.data.file;
                     this.btnRef.current.innerText = response.data.name;
                     this.btnRef.current.click();
                 },
                 error => console.log('error', error)
             );
    }


    handleGetUserTokenButton() {
        let token = getUserToken();

        console.log('USER TOKEN', token);
    }


    getContactRequests() {
        const token = sessionStorage.getItem('x-user-token') || false;

        if (!token) return false;


        axios.get('https://service.todab.org.tr/admin-contact-requests', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(
            response => {
                if (typeof response.status !== 'undefined' && response.status) {
                    this.setState({data: response.data.data});
                } else {
                    // was error
                }
            },
            error => alert('HATA')
        );
    }



    componentDidMount() {
        this.getContactRequests();
    }

    renderTable() {

        const buildName = (rec) => {
            return `${rec.stock.kategori_name.category_name} - ${rec.stock.tur_name.category_name} - ${rec.stock.cesit_name.category_name}`;
        }

        const columns = [
            {
                Header: 'Bayi No',
                id: 'bayiNo',
                accessor: 'stock.bayi.uye_kod',
                width: 130
            },
            {
                Header: 'Bayi Adı',
                id: 'bayiAdi',
                accessor: 'stock.bayi.unvani',
                width: 270
            },
            {
                Header: 'Stok Adı',
                id: 'tohumAdi',
                accessor: d => buildName(d),
                width: 300
            },

            {
                Header: 'Miktar',
                id: 'miktar',
                accessor: d => d.stock.miktar
            },

            {
                Header: 'Birim Fiyat',
                id: 'birimFiyat',
                accessor: d => `${d.stock.birim_fiyat || '-'} ₺`
            },

            {
                Header: 'Gönderen Kişi',
                accessor: 'gonderen_adsoyad'
            },

            {
                Header: 'Telefonu',
                accessor: 'gonderen_telefon',
                width:130
            },

            {
                Header: 'Email Adresi',
                accessor: 'gonderen_mail'
            },

            {
                Header: 'Mesajı',
                accessor: 'mesaj',
                width: 400
            },

            {
                Header: 'Tarih',
                accessor: 'created_at'
            }
        ];

        const langProps = {
            previousText: 'Geri',
            nextText: 'İleri',
            loadingText: 'Yükleniyor',
            noDataText: 'Kayıt Bulunamadı',
            pageText: 'Sayfa',
            ofText: 'toplam',
            rowsText: 'satır'
        };

        return (
            <ReactTable data={this.state.data} columns={columns} {...langProps} minRows={5} style={{minHeight:350}}
            filterable={true} />
        )
    }

    render() {

        return (
            <Container fluid style={{marginTop:100}}>
                <a style={{display:'none'}} ref={this.btnRef}>Bas</a>
                <Row>
                    <Col lg={8}>
                        <h3>İletişim İstekleri <Badge variant="secondary">(Tümü)</Badge></h3>
                    </Col>
                    <Col lg={4}>
                        <Button variant={'success'} onClick={() => this.getExcel()}>Rapor Al</Button>
                    </Col>
                </Row>


                <br/>
                <Row>
                    <Col>

                        {this.renderTable()}

                    </Col>
                </Row>

            </Container>
        )

    }

}

export default ContactRequestsAdmin;